import PropTypes from 'prop-types';
import React from 'react';
import { getChromeVersion, isEdge } from '../../util';

class AddGlowforge extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: false,
    };
  }
  componentDidMount() {
    const { downloadUrl } = this.props;
    if (window.sessionStorage.getItem('disallowedSetupChromeVersion')
      || getChromeVersion() >= 101 || isEdge()) {
      window.location.replace(downloadUrl);
    } else {
      window.location.replace('/setup/select');
    }
  }

  render() {
    return null;
  }
}

AddGlowforge.propTypes = {
  downloadUrl: PropTypes.string.isRequired,
};

export default AddGlowforge;



// WEBPACK FOOTER //
// ./app/components/setup/add-glowforge.jsx